import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const PageHeader = ({ title, subtitle, action }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 3 }}>
    <Box>
      <Typography variant="h5" sx={{ color: '#1565C0', fontWeight: 700 }}>{title}</Typography>
      {subtitle && (
        <Typography variant="body2" sx={{ color: '#757575', mt: 0.5 }}>{subtitle}</Typography>
      )}
    </Box>
    {action && <Box>{action}</Box>}
  </Box>
);

export default PageHeader;
